import Navbar from "react-bootstrap/Navbar";
import Figure from "react-bootstrap/Figure";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import projectLogo from "../beast-logo.png";

type Props = {
  selected: string;
};

const BeastNavbar = (props: Props) => {
  const home_class = (props.selected=="home" ? "page-cur" : "page-link");
  const adsorbate_class = (props.selected=="adsorbate" ? "page-cur" : "page-link");
  const reaction_class = (props.selected=="reaction" ? "page-cur" : "page-link");
  const about_class = (props.selected=="about" ? "page-cur" : "page-link");
  return (
    <header className="site-header shadow-sm" role="banner">
      <div className="wrapper">
        <div className="header-col-wrapper">
          <div className="header-col header-col-left site-title">
            <div className="pt-3 site-title site-title-sub">Beyond-<span className="small-caps">dft</span> Electrochemistry with</div>
            <div className="site-title site-title-sub">Accelerated and Solvated Techniques DB</div>
          </div>
          <div className="pt-3 header-col header-col-right">
            <img src={projectLogo} alt="BEAST logo" height="64px"/>
          </div>
        </div>

        <nav className="site-nav" role="navigation">
          <a href="#" className="menu-icon">
            <svg viewBox="0 0 18 15" alt="Menu">
              <title>Menu</title>
              <path fill="#424242" d="M18,1.484c0,0.82-0.665,1.484-1.484,1.484H1.484C0.665,2.969,0,2.304,0,1.484l0,0C0,0.665,0.665,0,1.484,0 h15.031C17.335,0,18,0.665,18,1.484L18,1.484z"/>
              <path fill="#424242" d="M18,7.516C18,8.335,17.335,9,16.516,9H1.484C0.665,9,0,8.335,0,7.516l0,0c0-0.82,0.665-1.484,1.484-1.484 h15.031C17.335,6.031,18,6.696,18,7.516L18,7.516z"/>
              <path fill="#424242" d="M18,13.516C18,14.335,17.335,15,16.516,15H1.484C0.665,15,0,14.335,0,13.516l0,0 c0-0.82,0.665-1.484,1.484-1.484h15.031C17.335,12.031,18,12.696,18,13.516L18,13.516z"/>
            </svg>
          </a>
          
          <div className="trigger">
            
            <a className={home_class} href="/beastdb">BEAST DB</a>
            <a className={adsorbate_class} href="/beastdb/database">Adsorbates</a>
            <a className={reaction_class} href="/beastdb/reaction_database">Reactions</a>
            <a className={about_class} href="/beastdb/about">Calculation details</a>
            <a className="page-link" href="https://beast-echem.org">BEAST</a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default BeastNavbar;
